import { useSelector } from "react-redux";
import { ARYADANA_COUNTRY } from "Views/Bills/const";

const useIsAryadana = () => {
  const orgDetails = useSelector(
    (state: any) => state.b2bOrgDetailReducer?.data?.payload || {},
  );
  const showAryadana = orgDetails?.countryCode === ARYADANA_COUNTRY;

  return Boolean(showAryadana);
};

export default useIsAryadana;
